import { WhatsAppSettings } from './whatsapp/WhatsAppSettings';

export function Settings() {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">الإعدادات</h2>
      <WhatsAppSettings />
    </div>
  );
}